import { Action } from '../../actions/inventory/index';
import { ActionType } from '../../actions-types';
import { CURRENT_ENV } from '@root/core/configs/env';

interface TypeLogin {
  type: string | undefined;
}

const initialTypeLogin: TypeLogin = { type: CURRENT_ENV.APP_ROLE };

const inventoryReducer = (
  state: TypeLogin = initialTypeLogin,
  action: Action
) => {
  switch (action.type) {
    case ActionType.GET_TYPE_LOGIN:
      return {
        ...initialTypeLogin,
        TypeLogin: action.payload
      };
    default:
      return state;
  }
};
type IdSeller = number;
const initialIdSeller = NaN;

export const getIdSellerReducer = (
  state: IdSeller = initialIdSeller,
  action: Action
) => {
  switch (action.type) {
    case ActionType.GET_ID_SELLER:
      return {
        initialIdSeller,
        IdSeller: action.payload
      };
    default:
      return state;
  }
};

export default inventoryReducer;
